var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Left",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.296,
    height: 24.582,
    viewBox: "0 0 14.296 24.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 14.296,
    height: 24.582,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#013",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M12.8,0C12.8,7.411,4.212,12.291,0,12.291",
    fill: "none",
    stroke: "#013",
    strokeLinejoin: "bevel",
    strokeWidth: 2.995
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M12.8,24.582c0-7.411-8.587-12.291-12.8-12.291",
    fill: "none",
    stroke: "#013",
    strokeLinejoin: "bevel",
    strokeWidth: 2.995
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSliderArrow);
export default __webpack_public_path__ + "static/media/leftSliderArrow.5b02caa7849fd4356174bacb49af975f.svg";
export { ForwardRef as ReactComponent };